// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Cp5c","controls":"styles_controls__q6fKc","charLimit":"styles_charLimit__2rXwp","input":"styles_input__1LCLe","send":"styles_send__318Vz"};